/**
 * <Field
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import getDefaultErrorMessages from './getDefaultErrorMessages';


class Field extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.renderField = this.renderField.bind(this);
  }

  componentWillMount() {

  }

  onChange(data) {
    const {
      item,
      onChange,
      formData,
    } = this.props;

    if (typeof item.outputTransform === 'function') {
      data = item.outputTransform(data, formData);
    }

    onChange(item.name, data);
  }

  renderField() {
    const {
      fields,
    } = this.props;

    const {
      type,
      placeholder,
      options,
      defaultValue,
      disabled,
      hidden,
      currency,
      mode,
      maxLength,
      rows,
      direction,
      content,
      fixValue,
      hasEndDate,
      allowNegative
    } = this.props.item;

    let value;
    if (typeof this.props.fieldData === 'undefined') {
      value = defaultValue;
    } else {
      value = this.props.fieldData;
    }


    switch (type) {
      case "text": {
        return (<input type={hidden ? 'hidden' : 'text'} disabled={disabled} value={value} className='form-control' placeholder={placeholder} onChange={(e)=>{ this.onChange(e.target.value); }} />);
        break;
      }

      case "number": {
        return (<input type={hidden ? 'hidden' : 'number'} value={value} className='form-control' placeholder={placeholder} onChange={(e)=>{ this.onChange(e.target.value); }} />);
        break;
      }

      case "email": {
        return (<fields.Email type='email' value={value || ""} className='form-control' placeholder={placeholder} onChange={this.onChange} />);
        break;
      }

      case "password": {
        return (<input type='password' value={value || ""} className='form-control' placeholder={placeholder} onChange={(e)=>{ this.onChange(e.target.value); }} />);
        break;
      }

      case "money": {
        return (<fields.Money hidden={hidden} disabled={disabled} currency={currency} value={value || fixValue} allowNegative={allowNegative} className='form-control' placeholder={placeholder} onChange={(value)=>{ this.onChange(value); }} />);
        break;
      }

      case "textarea": {
        return (<fields.Textarea value={value} className='form-control' placeholder={placeholder} onChange={(value)=>{ this.onChange(value); }} maxlength={maxLength} rows={rows} />);
        break;
      }

      case "checkbox": {
        return (<label className={classnames('control')}>
          <input type='checkbox' checked={value} value={value}  disabled={disabled} onChange={(e)=>{ this.onChange(value !== true); }} />
          <span className='checkmark'></span>{placeholder}
          </label>
        );
        break;
      }

      case "radio": {
        return (
          <fields.Radio onChange={this.onChange} value={value} options={options} />
        );
        break;
      }

      case 'custom': {
        const {
          component,
        } = this.props.item;

        return component(value, this.onChange, this.props.item, this.props);

        break;
      }

      case "gender": {
        return <fields.Gender onChange={this.onChange} value={value} />
        break;
      }

      case "datePicker": {
        return <fields.DatePicker onChange={this.onChange} value={value} hasEndDate={hasEndDate} />
        break;
      }

      case "dateTime": {
        return <fields.DateTime onChange={this.onChange} value={value} />
        break;
      }

      case 'timepicker': {
        return <fields.TimePicker2 onChange={this.onChange} value={value} />
      }
      case "address": {
        return <fields.Address onChange={this.onChange} value={value || {}} />
        break;
      }

      case "classBillingMethod": {
        return <fields.ClassBillingMethod onChange={this.onChange} value={value || {}} mode={mode} />
        break;
      }

      case "selectTeacher": {
        return <fields.SelectTeacher onChange={this.onChange} value={value} options={options} />
        break;
      }

      case "selectStudent": {
        return <fields.SelectStudent onChange={this.onChange} value={value} options={options} disabled={disabled} />
        break;
      }

      case 'select': {
        return (
          <select className='form-control' value={value} disabled={disabled} onChange={(e) => {this.onChange(e.target.value)}}>
            {options && options.map(({ label, value, disable }, key)=>{
              return <option key={key} value={value} disabled={disable} defaultValue={!disable}>{label}</option>
            })}
          </select>
        );
        break;
      }

      case 'name': {
        return (
          <fields.Name value={value} onChange={this.onChange} />
        );
        break;
      }

      case 'openhours': {
        return (
          <fields.Openhours value={value} onChange={this.onChange} />
        );
        break;
      }

      case 'agelimit': {
        return (
          <fields.Agelimit value={value} onChange={this.onChange} />
        );
        break;
      }

      case 'guardian': {
        return (
          <fields.Guardian value={value || {}} onChange={this.onChange} />
        );
        break;
      }

      case 'imageUploader': {
        return (
          <fields.ImageUploader value={value || {}} onChange={this.onChange} options={options} />
        );
        break;
      }

      case 'mediaCenter': {
        const {
          selectMultiple,
        } = this.props.item;

        if (typeof selectMultiple == 'undefined') {
          throw new Error('selectMultiple is required.');
        }

        return (
          <fields.MediaCenter value={value || {}} onChange={this.onChange} selectMultiple={selectMultiple} />
        );
        break;
      }

      case "phone": {
        return (<fields.ReactPhoneInput
          defaultCountry={'ca'}
          // onlyCountries={['ca', 'us']}
          value={value}
          className='form-control'
          onChange={(number)=>{
            this.onChange(number)
          }}
        />);
        break;
      }

      case "objectArray": {
        const {
          objectSchema,
        } = this.props.item;

        return (<fields.ObjectArray
          onChange={this.onChange}
          objectSchema={objectSchema}
          value={value}
        />);
        break;
      }

      case "reactSearch": {
        return (<fields.ReactSelect
          value={value || {}}
          onChange={this.onChange}
          options={options}
          disabled={disabled}
          direction={direction}
        />)
        break;
      }
      case 'weekdateSelect': {
        return <fields.WeekdateSelect onChange={this.onChange} value={value || []}/>;
      }
      case "customContent": {
        return (content)
        break;
      }

    }
  }

  render() {
    const {
      label,
      type,
      required,
      className,
      fieldStyle = 'outline',
      tip,
      hidden,
    } = this.props.item;

    const {
      failed,
      formStyle,
    } = this.props;

    let errorMessage;
    let hasError;
    
    if (failed && Array.isArray(failed.because) && failed.because.length > 0) {
      hasError = true;
      errorMessage = getDefaultErrorMessages(failed.because[0]);
    }

    const hasNoLabel = typeof label === "undefined";

    const fieldClassName = classnames('Field form-group', className, `form-type-${type}`, `field-style-${fieldStyle}`, { hasError, hasNoLabel });

    if (formStyle === 'inline') {
      return (
        <div>
          {!hidden && <div className={fieldClassName}>
            { (!hasNoLabel && !hidden) &&
              <label className='col-sm-3 control-label'>{label}
                { required && <span className='ast'>*</span> }
              </label>
            }
            <div className='col-sm-9'>
              <div className='control-input'>
                {this.renderField()}
                { (hasError && !hidden) && <div className='errorMsg'>{errorMessage}</div> }
              </div>
              { typeof(tip) !== 'undefined' && <div className='tip'>
                {tip}
              </div> }
            </div>
          </div>}
        </div>
      );
    } else if (formStyle === 'outline') {
      return (
        <div>
          {!hidden && <div className={fieldClassName}>
            { (!hasNoLabel && !hidden) &&
              <label className='control-label'>{label}
                { required && <span className='ast'>*</span> }
              </label>
            }
            {!hidden && <div className='control-input'>
              {this.renderField()}
              { (hasError && !hidden) && <div className='errorMsg'>{errorMessage}</div> }
            </div>}
            { typeof(tip) !== 'undefined' && <div className='tip'>
              {tip}
            </div> }
          </div>}
        </div>
      );

    }
  }
}

export default Field;



// WEBPACK FOOTER //
// ./src/components/Form/Field.js